import isEmpty from 'lodash/isEmpty';
import { Action, Middleware, Dispatch, MiddlewareAPI } from 'redux';

import { actions as authActions } from 'services/auth';

// eslint-disable-next-line consistent-return
const tokenMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: Action) => {
  const blacklist = ['LOGIN', 'REMOVE_MAINTENANCE_TOKEN', 'REMOVE_ADMIN_TOKEN'];
  const shouldBlacklist = blacklist.reduce((acc, type) => acc || action.type.includes(type), false);

  if (action.type.includes('REQUEST') && !shouldBlacklist) {
    const admin = store.getState().auth.admin;
    const token = localStorage.getItem('token');

    if (!isEmpty(admin) && token) {
      const expiration = admin.exp;
      if (expiration < Date.now() / 1000) return store.dispatch(authActions.removeAdminToken());
    } else {
      localStorage.removeItem('maintenance_token');

      return [store.dispatch(authActions.removeMaintenanceToken()), store.dispatch(authActions.removeAdminToken())];
    }
  }
  next(action);
};

export default tokenMiddleware;
